export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RESULT_PER_PAGE = 10;
export const KEY = 'a6056569-e5d3-48a0-a423-2caf764fd385';
export const MODAL_CLOSE_SEC = 2.5;
